import { jsx } from "react/jsx-runtime";
import "react";
import { Dialog } from "pcln-design-system";
import RealTimeVoiceModalInfo from "../../../Voice/RealTimeVoiceModalInfo.js";
const RealtimeInfoModal = ({ setShowRealTimeInfoModal, setShowVoiceTooltip, showRealTimeInfoModal })=>/*#__PURE__*/ jsx(Dialog, {
        ariaDescription: "Realtime Information Modal",
        ariaTitle: "Information about Realtime Voice Chat",
        borderRadius: "2xl",
        headerColorScheme: "neutralDarkOnLightest",
        onOpenChange: function(open) {
            setShowRealTimeInfoModal(open);
            setShowVoiceTooltip(open);
            if (!open) localStorage.setItem('userClosedVoiceModeTooltip', 'true');
        },
        overflowX: "auto",
        overflowY: "auto",
        scrimColor: "dark",
        scrimDismiss: true,
        showCloseButton: true,
        size: "md",
        open: showRealTimeInfoModal,
        children: /*#__PURE__*/ jsx(RealTimeVoiceModalInfo, {
            onContinue: function() {
                setShowRealTimeInfoModal(false);
                setShowVoiceTooltip(false);
                localStorage.setItem('userClosedVoiceModeTooltip', 'true');
            }
        })
    });
const VoiceControlButton_RealtimeInfoModal = RealtimeInfoModal;
export { VoiceControlButton_RealtimeInfoModal as default };
